(function() {
  define('tlhServicesNotification',['angular', 'angularUiNotification'], function() {
    'use strict';
    return angular.module('tlhServicesNotification', ['ui-notification']).factory('TlhNotificationService', [
      'Notification', function(Notification) {
        var factory;
        factory = {};
        factory.info = function(options) {
          options.message = '<i class="fa fa-circle-o-notch fa-spin"></i>&nbsp; ' + options.message;
          return Notification.info(options);
        };
        factory.success = function(options) {
          options.message = '<i class="fa fa-check"></i>&nbsp; ' + options.message;
          return Notification.success(options);
        };
        factory.warning = function(options) {
          options.message = '<i class="fa fa-warning"></i>&nbsp; ' + options.message;
          return Notification.warning(options);
        };
        factory.error = function(options) {
          options.message = '<i class="fa fa-warning"></i>&nbsp; ' + options.message;
          return Notification.error(options);
        };
        return factory;
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=notification.js.map
;
